import { createSlice, PayloadAction, Reducer } from "@reduxjs/toolkit";
import { VisitorTracking } from "@brandclub/common-ui";

export interface VisitorTrackingState {
  status: "idle" | "loading" | "success" | "failed";
  visitorTracking?: VisitorTracking;
  error?: string;
}

const initialState: VisitorTrackingState = {
  status: "idle",
};

const visitorTrackingSlice = createSlice({
  name: "visitorTracking",
  initialState,
  reducers: {
    updateVisitorTracking: (state, action: PayloadAction<VisitorTracking>) => {
      state.status = "success";
      state.visitorTracking = action.payload;
    },
  },
});

export const { updateVisitorTracking } = visitorTrackingSlice.actions;

const reducer: Reducer<VisitorTrackingState> = visitorTrackingSlice.reducer;
export default reducer;
